export const getNewGruserPortFlagName = section => {
  let newGruserPortFlagName;
  switch (section) {
    case 'backroom':
      newGruserPortFlagName = 'gruser_backroom';
      break;
    default:
      newGruserPortFlagName = 'gruser_flag_that_dont_exist';
  }
  return newGruserPortFlagName;
};

export const isReleasedGrusers = section =>
  [
    'about',
    'home',
    'shop',
    'posts',
    'gallery',
    'favourites',
    'private_collections',
    'subscriptions',
  ].includes(section);
